import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_DK_UQ || "uq.dk.styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_DK_UQ || "uqdk-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_DK_UQ || 24197,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_DK_UQ || 24198,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_DK_UQ ||
    "1:160978693362:web:5feb8d6f84b032eb47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-TEL6Q5D83K" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.DA, LANGUAGE.EN],
  countryRegion: "Europe/Copenhagen",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    },
    [LANGUAGE.DA]: {
      defaultTimezone: "CET",
      offset: {
        CET: 1,
        CEST: 2
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.DA]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>",
    [LANGUAGE.DA]: "<dd>/<mm>"
  },
  requireDecimal: false,
  memberPricingEnabled: true
};

export default _countryEnv;
